import {useQuery} from "@tanstack/react-query";
import type {HeatsRankings} from '@iziping/common';
import type {ApiError} from '@iziping/common';
import { ENDPOINTS, QUERY_CACHE } from '@/model/endpoints';
import { apiClient } from '@iziping/common';

interface HeatsResultsParams {
    tournamentId: number;
}

export const useGetHeatsResults = (params: HeatsResultsParams) => {
    return useQuery<HeatsRankings[], ApiError>({
        queryKey: [QUERY_CACHE.HEATS_RESULTS],
        queryFn: async () => {
            const response = await apiClient.get<HeatsRankings[]>(`${ENDPOINTS.heatsResults(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};